var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });


$('.product__accordion').hide();
$('.product_btmcontent').hide();
 $('input[name=Choose]').on('click', function() {
        var clickedValue = $(this).attr('data-oname');
        $('.product__accordion, .product-metafiled-content > div').hide();
        $('#' + clickedValue + ', .' + clickedValue + '-grid').show();
    });

$('input[name=Choose]:checked').trigger('click');

// $('.measuring_anatomy_para2, .measuring_anatomy_para3').hide();

// $('[class^="measuring_anatomy_head"]').hover(
//   function() {
//     var currentPara = $(this).attr('class').replace('head', 'para');
//     $('.measuring_anatomy_para1').hide();
//     $('.' + currentPara).show();
//   },
//   function() {
//     var currentPara = $(this).attr('class').replace('head', 'para');
//     $('.' + currentPara).hide();
//     $('.measuring_anatomy_para1').show();
//   }
// );

$('a[title="open-popup"]').fancybox();

$('.faq_readmore').click(function(){
    $('.for_readless_btn.expertfaq_common').show();
    $('.commn-btn .faq_readmore').hide();
    $('.readmore_btn').hide();
    $('.commn-btn.r-less').show();
})
$('.faq_readless').click(function(){
     $('.for_readless_btn.expertfaq_common').hide();
     $('.commn-btn .faq_readmore').show();
     $('.readmore_btn').show();
     $('.commn-btn.r-less').hide();
})

$('.recover_password').click(function(){
    $('.login_div').hide();
    $('.sagsad').show();
})
$('.login_cancel').click(function(){
    $('.login_div').show();
    $('.sagsad').hide();
});

// $('.round-image-col .custom-tab-trigger').click(function(){
//     var get_name = $(this).data('name');
//     $('.work-tab-section').find('.tab-heading01[data-name="'+get_name+'"]').trigger('click');
//     $('html, body').animate({
//       scrollTop: $(".work-tab-section").offset().top
//     }, 500);
// })


$('.footer-block--menu h2.footer-block__heading').click(function() {
  $(this).parents('.menu-custom-wraper').toggleClass('active');;  
});

$(".shopify-payment-button__button--shoppay").on('click', function (event) {
  event.preventDefault();
	  $( ".shopify-payment-button__more-options").trigger( "click");
});

$("header-menu details").hover(function(){
    $(this).attr('open',true);
    $(this).find('summary').attr('aria-expanded',true);
  }, function(){
    $(this).attr('open',false);
    $(this).find('summary').attr('aria-expanded',false);
});


 // $(".fitting-tabs-grid .fitting-tabs").click(function(){
 //    if(!$(this).hasClass('active')){
 //     $(".fitting-tabs").removeClass('active');
 //     var get_id = $(this).data('id');
 //      var get_index = $(this).data('index');
 //      console.log(get_index);
 //     $('.fitting-guide-contentgrid').find('.guide-content').removeClass('active-tab');
 //     $('#'+get_id).addClass('active-tab');
 //     $(this).addClass('active');
 //  $('.step6-fitting').find('.step-main-grid[data-index="'+get_index+'"]').trigger('click');
 //    }   
 // }); 


    $(".fitting-tabs-grid .fitting-tabs").click(function() {
        if (!$(this).hasClass('active')) {
            $(".fitting-tabs").removeClass('active');
            $(this).addClass('active');   
            var get_id = $(this).data('id');
            var get_index = $(this).data('index');
            $('.fitting-guide-contentgrid .guide-content').removeClass('active-tab');
            $('#' + get_id).addClass('active-tab');
            $('.step-main-grid').removeClass('active');
            var $activeStepMainGrid = $('.step-main-grid[data-index="' + get_index + '"]');
        $activeStepMainGrid.addClass('active');
         if ($activeStepMainGrid.hasClass('hide-div')) {
            $('.fitting_g_slider.step6-fitting').hide();
         } else {
            $('.fitting_g_slider.step6-fitting').show();
           }
        }
    });






